import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22",
      cy: "22.5",
      r: "22",
      fill: "#F8F8F8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFDD2D",
      d: "M11 13.5h22v11.069a7.944 7.944 0 0 1-3.967 6.88l-7.028 4.062-7.027-4.063a7.932 7.932 0 0 1-3.967-6.88V13.5H11Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#333",
      "fill-rule": "evenodd",
      d: "M17.035 19.324v3.44c.475-.528 1.33-.886 2.3-.886h1.066v3.999c0 1.065-.285 1.994-.717 2.511h4.621c-.432-.517-.717-1.446-.717-2.511v-4h1.065c.982 0 1.836.36 2.3.887v-3.44h-9.918Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }